import productFieldServices from '../../../services/notisphere/product-field'
import { PRODUCT_FIELD_DATA_TYPE, PRODUCT_FIELD_DATA_TYPE_OPTIONS_DATE } from '../../../misc/commons'
import { Notisphere_ProductField_AgGrid, AG_GridCustomizedTableHeaders_Key } from '../../../misc/tableHeaders'
import ProFieModal from './ProFieModal'
import _ from 'lodash'

export default {
    components: {
        ProFieModal
    },
    data() {
        return {
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
            },
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            total: 0,
            items: [],
            gridApi: null,
            columnApi: null,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            proFieModalKey: 0,
            productFieldDataType: PRODUCT_FIELD_DATA_TYPE,
            productFieldDataTypeOptionDate: PRODUCT_FIELD_DATA_TYPE_OPTIONS_DATE,
            search: {},
        }
    },
    beforeMount() {
        this.columnDefs = Notisphere_ProductField_AgGrid
    },
    created() {
        this.rowModelType = 'serverSide'
    },
    methods: {
        onCompleted(type) {
            if (type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        },
        addMoreClick() {
            this.proFieModalKey += 1
            this.$nextTick(()=>{
                this.$refs.proFieModal.forceRerenderInsert()
            })
        },
        updateProFie(payload) {
            this.proFieModalKey += 1
            this.$nextTick(()=>{
                this.$refs.proFieModal.forceRerenderUpdate(payload.name)
            })
        },
        fetchData(params) {
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const datasource = {
                getRows(params) {
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.search.filterModel = that.gridApi.getFilterModel()
                    productFieldServices.findProductField({
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        search: that.searchQuery.globalSearch,
                        ...that.search,
                    }).then(resp => {
                        if (!resp.error) {
                            that.total = resp.data.d.t
                            if (that.total == 0) {
                                that.gridApi.showNoRowsOverlay()
                            } else {
                                that.gridApi.hideOverlay()
                            }
                            return resp.data.d.c
                        }
                    }).then(response => {
                        params.successCallback(response)
                    }).catch(error => {
                        console.error(error)
                        params.failCallback()
                    })
                }
            }
            // register datasource with the grid
            params.api.setServerSideDatasource(datasource)
        },
        deleteProductField(item, e) {
            this._showConfirm('You are about to delete this product field, this cannot be undone.').then(confirm=>{
                if(confirm) {
                    productFieldServices.deleteProductField(item.name).then(resp=>{
                        if (!resp.error) {
                            this.onCompleted('UPDATE')
                        }
                    })
                }
            })
            if (e) {
                e.stopPropagation()
            }
        },
        // AG Grid specific methods
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const searchquery = JSON.parse(JSON.stringify(this.searchQuery))
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...searchquery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        filterModel: params.api.getFilterModel(),
                        search: that.searchQuery.globalSearch,
                        email: email,
                    }
                    const resp = await productFieldServices.downloadAgGridProductFieldXLSX(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.ProductField_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.ProductField_Headers
            if (columnState) {
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            }
        },
        onFilterChanged(event) {
            this.table_Connection_Data.Notisphere_Login.ProductField_Filters = event.api.getFilterModel()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        setFilterModel(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var filterModel = tableState?.Notisphere_Login?.ProductField_Filters
            if (filterModel) {
                params.api.setFilterModel(filterModel)
            }
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onCellClicked(params) {
            if (params.column.colId === 'actions') {
                if (params.event.target.dataset.action === 'delete') {
                    this.deleteProductField(params.data, params.event)
                }
                return
            }
            // Row click to edit
            this.updateProFie(params.data)
        },
        onGlobalSearchChange(searchValue) {
            // Handle global search - you can implement text search across all columns
            this.searchQuery.globalSearch = searchValue
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }
    }
}
